"use client";

import { c as _c } from "react/compiler-runtime";
import { api } from "@agroproj/backend/convex/_generated/api";
import { useQuery } from "convex/react";
import { Section } from "@/components/ui/section";
import { Skeleton } from "@/components/ui/skeleton";
import { StatGrid, StatTile } from "@/components/ui/stat";
import { formatCurrencyBRL } from "@/lib/format";

/** Aggregated project money totals for the organization dashboard (values in reais). */
export function FinancialSummary(t0) {
  const $ = _c(17);
  const {
    subscriptionLocked: t1
  } = t0;
  const subscriptionLocked = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== subscriptionLocked) {
    t2 = subscriptionLocked ? "skip" : {};
    $[0] = subscriptionLocked;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const projectDashboard = useQuery(api.projects.queries.getProjectsDashboard, t2);
  const isLoading = !subscriptionLocked && projectDashboard === undefined;
  const t3 = projectDashboard?.totalInvestment ?? 0;
  let T0;
  let T1;
  let t4;
  let t5;
  if ($[2] !== isLoading || $[3] !== projectDashboard?.totalRevenue || $[4] !== subscriptionLocked || $[5] !== t3) {
    const items = [{
      label: "Investimento estimado",
      value: t3,
      tone: "default" as const
    }, {
      label: "Receita bruta esperada",
      value: projectDashboard?.totalRevenue ?? 0,
      tone: "positive" as const
    }];
    T1 = Section;
    t5 = "Resumo financeiro";
    T0 = StatGrid;
    t4 = items.map(item => <StatTile key={item.label} label={item.label} tone={item.tone} value={isLoading ? <Skeleton className="h-6 w-32" /> : subscriptionLocked ? "-" : formatCurrencyBRL(item.value)} />);
    $[2] = isLoading;
    $[3] = projectDashboard?.totalRevenue;
    $[4] = subscriptionLocked;
    $[5] = t3;
    $[6] = T0;
    $[7] = T1;
    $[8] = t4;
    $[9] = t5;
  } else {
    T0 = $[6];
    T1 = $[7];
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[10] !== T0 || $[11] !== t4) {
    t6 = <T0>{t4}</T0>;
    $[10] = T0;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== T1 || $[14] !== t5 || $[15] !== t6) {
    t7 = <T1 title={t5}>{t6}</T1>;
    $[13] = T1;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}